interface ShadowTestGtiItem {
  gti?: string;
  passed?: boolean;
  usecase?: string;
}

export interface ShadowTestGtiGroup<T> {
  gti?: string;
  items: T[];
  passed?: boolean;
  usecases: string[];
}

export function groupShadowTestItemsByGti<T extends ShadowTestGtiItem>(
  items: T[]
): ShadowTestGtiGroup<T>[] {
  const groupedItems = items.reduce<Map<string, T[]>>((groups, item) => {
    const gti = item.gti?.trim() || "";
    const group = groups.get(gti);
    if (group) {
      group.push(item);
    } else {
      groups.set(gti, [item]);
    }
    return groups;
  }, new Map());

  return Array.from(groupedItems.entries())
    .sort(([left], [right]) => {
      if (!left && !right) return 0;
      if (!left) return 1;
      if (!right) return -1;
      return left.localeCompare(right);
    })
    .map(([gti, groupItems]) => {
      const hasFailedItem = groupItems.some((item) => item.passed === false);
      const allItemsPassed = groupItems.every((item) => item.passed === true);
      let passed: boolean | undefined;
      if (hasFailedItem) {
        passed = false;
      } else if (allItemsPassed) {
        passed = true;
      }

      return {
        gti: gti || undefined,
        items: groupItems,
        passed,
        usecases: Array.from(
          new Set(
            groupItems
              .map((item) => item.usecase)
              .filter((usecase): usecase is string => Boolean(usecase))
          )
        ).sort(),
      };
    });
}
